module.exports = __webpack_public_path__ + "img/Liechtensteiner.0d3867b5.svg";